import { Box } from '@mui/material';
import React from 'react';
import MapSection from '../component/MapSection';

const MainPage = () => {
	return (
		<Box sx={{ width: '100%', height: '100%' }}>
			<MapSection />
		</Box>
	);
};

export default MainPage;
